var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-3 primary text-body-2 rounded-lg",staticStyle:{"text-transform":"none","border":"1px solid primary"},attrs:{"depressed":""},on:{"click":function($event){return _vm.loginorsignup('signup')}}},[_vm._v("Sign Up")])}
var staticRenderFns = []

export { render, staticRenderFns }